/* eslint-disable react/display-name */
import React, { useContext, useEffect } from 'react'
import { Modal } from 'antd'
import { StationSelection } from 'core'
import { UnitSelectionContext } from 'context'
import { connect } from 'react-redux'
import * as Selectors from 'core/selectors'
import R from 'ramda'
const SelectReport = props => {
  const { setVisibleUnitSelection } = useContext(UnitSelectionContext)
  useEffect(_ => setVisibleUnitSelection(props.visible), [
    props.visible,
    setVisibleUnitSelection,
  ])

  const { station, setStation } = props

  let reportStations = []
  const {
    // userCompany,
    // companyUtilityMap,
    userStation,
    userRoleType,
    units,
    actionPermits,
    stationList,
    filterStation = _ => true,
  } = props

  if (actionPermits.includes('admin')) {
    reportStations = units.map(u => u.station).filter(s => s !== undefined)
  } else if (userRoleType.includes('STATION')) {
    reportStations = userStation
  } else if (userRoleType.includes('COMPANY')) {
    // const utility = R.flatten(userCompany.map(c => companyUtilityMap[c] || []))
    // // .flat()
    // reportStations = units
    //   .filter(u => u.station !== undefined && utility.includes(u.utility))
    //   .map(u => u.station)
    // utility has null in the company_id field
    reportStations = units
      .filter(u => u.station !== undefined)
      .map(u => u.station)
  }
  const stationIdList = stationList.map(s => s.station)
  reportStations = R.uniq(reportStations)
    .filter(s => stationIdList.includes(s))
    .filter(filterStation)

  return (
    <Modal
      footer={null}
      // title={props.title}
      visible={props.visible}
      onOk={e => {
        setVisibleUnitSelection(false)
        props.onOk(e)
      }}
      onCancel={_ => {
        setVisibleUnitSelection(false)
        props.onCancel()
      }}
      width={1000}
      style={{ top: 10 }}
      afterClose={_ => setVisibleUnitSelection(false)}
      destroyOnClose
    >
      <StationSelection
        accesskey="u"
        style={{ margin: '0px', padding: '0px' }}
        hideSelectedUnits={false}
        setData={props.modalClose}
        close={props.modalClose}
        title="Select Station"
        showSelection
        station={station}
        selectedStation={setStation}
        avaliableStations={reportStations}
        showwarning={false}
      />

      {/* <UnitSelection
        accesskey="u"
        style={{ margin: '0px', padding: '0px' }}
        hideSelectedUnits={true}
        setData={props.modalClose}
        close={props.modalClose}
      /> */}
    </Modal>
  )
}

const mapStateToProps = state => ({
  userRoleType: Selectors.getUserRoleType(state),
  userCompany: Selectors.getUserCompany(state),
  userStation: Selectors.getUserStation(state),
  companyUtilityMap: Selectors.getCompanyUtilityMap(state),
  actionPermits: Selectors.getPermitActions(state),
  units: Selectors.getUnits(state),
  stationList: Selectors.getStations(state),
})

export default connect(mapStateToProps)(SelectReport)
